// Store „vycucnutého" chrome legacy oken (titulek + akce z hlavičky Magic okna).
// Klíčováno per layerId; plní ho listener `useLegacyWindowChrome`, čte hlavička okna.

import { create } from 'zustand';

import type { WindowChromeData } from '@/shared/legacyMagicBridge';

interface LegacyWindowChromeState {
  readonly byLayer: Readonly<Record<string, WindowChromeData>>;
  set: (layerId: string, chrome: WindowChromeData) => void;
  prune: (layerIds: readonly string[]) => void;
}

export const useLegacyWindowChromeStore = create<LegacyWindowChromeState>((set) => ({
  byLayer: {},
  set: (layerId, chrome) => set((s) => ({ byLayer: { ...s.byLayer, [layerId]: chrome } })),
  prune: (layerIds) =>
    set((s) => {
      const keep = new Set(layerIds);
      const ids = Object.keys(s.byLayer);
      if (ids.every((id) => keep.has(id))) return s;
      const next: Record<string, WindowChromeData> = {};
      for (const id of ids) if (keep.has(id)) next[id] = s.byLayer[id] as WindowChromeData;
      return { byLayer: next };
    }),
}));
